import { Box } from '@chakra-ui/react';

import SwitchTab from 'UiKit/switch-tab';
import { useHostPresenceContentState } from 'View/host-presence-content/state';
import useGetTabOptions from './useGetTabOptions';

import styles from './styles.module.css';

const Tab = () => {
  const { state, updateState, updateFilterState, resetFilterState } = useHostPresenceContentState();
  const { selectedTab } = state;

  const onChangeTab = (newSelectedTab) => {
    if (selectedTab !== newSelectedTab) {
      updateState({ selectedTab: newSelectedTab });
      updateFilterState({ page: 1 });
      resetFilterState();
    }
  };

  return (
    <Box className={styles['tab__container']} data-testid="tab">
      <SwitchTab options={useGetTabOptions()} value={selectedTab} handleChange={onChangeTab} variant="line" />
    </Box>
  );
};

export default Tab;
